require('./kendo.core.js');
require('./kendo.fx.js');
require('./kendo.data.odata.js');
require('./kendo.data.xml.js');
require('./kendo.data.js');
require('./kendo.data.signalr.js');
require('./kendo.binder.js');
require('./kendo.validator.js');
require('./kendo.router.js');
require('./kendo.view.js');
require('./kendo.userevents.js');
require('./kendo.draganddrop.js');
require('./kendo.popup.js');
require('./kendo.touch.js');
require('./kendo.mobile.scroller.js');

"bundle all";
var kendo$1 = kendo;

module.exports = kendo$1;
